import { IDiscountInfo, IPromotion } from 'common/promotion';

export enum SeatClass {
  NON_REFUNDABLE = 'NR',
  NO_FREE_BAGGAGE = 'NB',
  SPECIAL_DEAL = 'L',
  DISCOUNT = 'D',
  ECONOMY = 'Y',
  BUSINESS = 'C',
}

export enum FilterTab {
  SEAT_CLASS = 'seat',
  AIRLINE = 'airline',
  TIME_AND_PRICE = 'deptime',
}

export interface IBookingParams {
  airlineCode: string;
  fitName: string;
  depCity: string;
  arrCity: string;
  departureDateTime: string;
  arrivalDateTime: string;
  seatClass: string;
  etc: string;
  seatCnt: number;
  adultFare: number;
  childFare: number;
  aFuel: number;
  cFuel: number;
  aTax: number;
  cTax: number;
  publishFee: number;
}

export interface IData {
  domesticFlights?: IDomesticFlights;
  promotions?: IPromotion[];
}

export interface IDomesticFlights {
  [field: string]: IFlight[];
}

export interface IFlight {
  [sortBy: string]: boolean | number | string | IFare[];
  airlineCode: string;
  airlineName: string;
  codeshare: string;
  fitName: string;
  depCity: string;
  arrCity: string;
  departureCityName: string;
  arrivalCityName: string;
  departureDate: string;
  arrivalDate: string;
  dayDiff: number;
  departureTime: string;
  arrivalTime: string;
  detailedClass: SeatClass;
  seatClass: SeatClass;
  seatCnt: number;
  journeyTime: string;
  minFare: number;
  supportNPay: boolean;
  fare: IFare[];
}

export interface IFare {
  agtCode: string;
  bookingClass: string;
  adultFare: number;
  childFare: number;
  aFuel: number;
  cFuel: number;
  aTax: number;
  cTax: number;
  publishFee: number;
  etc: string;
  supportNPay: boolean;
  discountFare: IDiscountFare;
}

interface IDiscountFare {
  adultDiscountFare: number;
  childDiscountFare: number;
  discountInfo: IDiscountInfo;
}
